import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import staticRoutes from './routes';
import { dynamicRoutesManager } from './dynamic-routes';
import NavigationService from '@/module/configuration/navigation/services/NavigationService';
import store from '@/store';
import _ from 'lodash';
import { findFirstAccessibleRoute } from '@/middlewares/check-rules';
import { dataResolverGuard, applyResolversToRoutes } from './route-resolvers';
import { initializeRouteResolvers } from './register-resolvers';

Vue.use(VueRouter);

const createRouter = () => {
  // Inicializar los resolvers para las rutas antes de crear el router
  initializeRouteResolvers();

  // Aplicar los resolvers a las rutas existentes
  const processedRoutes = applyResolversToRoutes(staticRoutes);

  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: processedRoutes, // Usar rutas con resolvers aplicados
    scrollBehavior(to, from, savedPosition) {
      return savedPosition || { x: 0, y: 0 };
    }
  });

  // Configurar el manager de rutas dinámicas
  dynamicRoutesManager.setRouter(router);

  // Inicializar rutas dinámicas con las reglas actuales
  const initialRules = NavigationService.getNavigationRules();
  dynamicRoutesManager.updateRoutesFromNavigation(initialRules);

  // Escuchar cambios en las reglas de navegación
  window.addEventListener('navigation-rules-updated', () => {
    const updatedRules = NavigationService.getNavigationRules();
    dynamicRoutesManager.updateRoutesFromNavigation(updatedRules);
  });

  // Aplicar el guardia de resolvers globalmente (para rutas dinámicas o que no tienen resolvers específicos)
  router.beforeEach(dataResolverGuard);

  // Add a global navigation guard specifically for login redirection
  router.beforeEach((to, from, next) => {
    // Special handling for login route when user is already authenticated
    if (to.name === 'login') {
      const profile = JSON.parse(localStorage.getItem('profile') || '{}');
      const isLoggedIn = store.getters['login/isLoggedIn'];
      
      console.log('Global before each - Login route check:', { 
        route: to.name, 
        isLoggedIn, 
        hasProfile: !!profile?.id 
      });
      
      if (profile?.id && isLoggedIn) {
        const roles = store.getters['login/roles'];
        console.log('User roles in global guard:', roles);
        
        // If user is manager, go to dashboard
        if (_.some(roles, {'manager': true})) {
          console.log('Redirecting manager from login to dashboard (global guard)');
          next({ name: 'dashboard' });
          return;
        }
        
        // Otherwise find first accessible route
        const accessibleRoute = findFirstAccessibleRoute(roles);
        console.log('Global guard redirecting user from login to:', accessibleRoute);
        next({ name: accessibleRoute });
        return;
      }
    }
    
    // Continue with normal flow for other routes
    next();
  });

  // Original route existence check
  router.beforeEach((to, from, next) => {
    // Solo verificar si la ruta existe
    if (to.matched.length === 0) {
      next('/');
      return;
    }
    next();
  });

  return router;
};

export default createRouter();
